import state from "./application-standalone-state";
import mutations from "./application-standalone-mutations";
import actions from "./application-standalone-actions";
import getters from "./application-standalone-getters";
const ApplicationStandaloneStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
export default ApplicationStandaloneStore;